module.exports = __webpack_public_path__ + "static/img/微信支付@2x.ec4dd16.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/微信支付@2x.png
// module id = 784
// module chunks = 358